var map = {
	"./BatchFileUpload": 810,
	"./BatchFileUpload.tsx": 810,
	"./ImportProgressPage": 811,
	"./ImportProgressPage.tsx": 811,
	"./SingleCaseGroupPage": 815,
	"./SingleCaseGroupPage.tsx": 815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1165;